import React, { Component } from "react";
import { observer } from "mobx-react";
import NowTimeView from "./NowTimeView";
import Clock from "react-live-clock";
import { Link } from "react-router-dom";
import { fn_show_setting } from "../../../function/FnBodySetting";
import { fn_bridge_close } from "../../../function/FnPosBridge";
import { analyticeEvent } from "utils/Utils"
import SearchStore from "stores/SearchStore";

@observer
class MainTopView extends Component {

    render() {
        const { rootStore, topText } = this.props;

        return (
            <div id="dummerHeader">
                <h1>
                    <Link to="/order_list" onClick={event => fn_bridge_close(rootStore)}>
                        <button>OKPOS</button>
                    </Link>
                    {/* <a href="/test.html">
                        <button>OKPOS</button>
                    </a> */}
                </h1>
                <div className="menu">
                    <button type="button"
                        onClick={event => fn_show_setting(rootStore, true)}
                    >
                        <span className="screen_out">메뉴열기</span>
                    </button>
                </div>
                <h2>{topText}</h2>
                <NowTimeView rootStore={rootStore} />
                <div className="list">
                    <Link to="/order_list">
                        <button type="button"><span>주문현황</span>
                        </button>
                    </Link>
                </div>
                <Link to="/setting/notice">
                    <div className="alarm" onClick={event => analyticeEvent("notice", "notice button", SearchStore.getShopCd)} >
                        <span className={rootStore.settingStore.getNoticeNew === "Y" ? "ico" : ""}></span>
                        <span className="screen_out">공지사항목록</span>
                    </div>
                </Link >
                <div className="close">
                    <Link to="/order_list" onClick={event => fn_bridge_close(rootStore)}>
                        <span className="screen_out">프로그램종료</span>
                    </Link>
                </div>
            </div >
        );
    }
}

export default MainTopView;